export enum RefusedTransactionStatus {
    ACTIVE = 'ACTIVE',
    SOLVED = 'SOLVED',
    ACKNOWLEDGED = 'ACKNOWLEDGED',
    ANY = 'ANY'
}